import axios from 'axios';
import URL from './confURL'

const commonAxios = (method = 'GET', params, url) => {
    const axiosSet = axios.create({
        baseURL: URL.BACKEND_URL,
        headers: {
            "Content-Type": 'application/json'
        },
        withCredentials: true
    })

    let axiosResult = null;

    if (method === 'POST') {
        axiosResult = axiosSet.post(url, params);
    } else {
        axiosResult = axiosSet.get(url);
    }

    return axiosResult;
};

export default commonAxios;
